module.exports = __webpack_public_path__ + "img/reifentechnik_basiswissen_784x514.77fd6c64.jpg";